import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { getDeviationTitle, getDeviationType, isHyped } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import Title from '../_partials/Title';
import AdoptableOwner from '../_partials/AdoptableOwner';
import DeviationFlags from '../../ActionBar/buttons/DeviationFlags';

import s from './MobileSubmissionDetails.scss';

export interface Props {
  deviation: PapiDeviation;
  isOwner: boolean;
  showTitle?: boolean;
  className?: string;
}

const MobileSubmissionDetails: React.FC<Props> = ({
  className,
  deviation,
  deviation: { dailyDeviation, premiumFolderData },
  showTitle,
}) => {
  const deviationTitle = getDeviationTitle(deviation);
  const isTextual = [DeviationTypes.LITERATURE].includes(getDeviationType(deviation));
  const { isPremium, isPaidFolder } = normalizePremiumFolderData(premiumFolderData);
  const isPremiumNonLit = isPremium && !isTextual;

  const adoptable = deviation.extended?.adoptable;
  const hyped = isHyped(deviation);
  const isStashItem = deviation?.isPublished === false;

  return (
    <div
      className={classnames(
        s['root'],
        className,
        (dailyDeviation || hyped || isStashItem) && s['with-flag'],
        dailyDeviation && hyped && s['with-both-flags']
      )}
    >
      {(dailyDeviation || hyped || isStashItem) && showTitle && (
        <div className={s['flag']}>
          <DeviationFlags deviation={deviation} />
        </div>
      )}
      {isPremiumNonLit && (
        <>
          {isPaidFolder ? (
            <PremiumGallery className={s['folder-icon']} size={IconSize.SMALL} />
          ) : (
            <EyeDisc2 className={s['folder-icon']} size={IconSize.SMALL} />
          )}
        </>
      )}
      <Title
        title={deviationTitle}
        showTitle={showTitle}
        className={classnames(s['title'], isPremiumNonLit && s['title-with-folder-icon'])}
      />
      {adoptable && <AdoptableOwner className={s['adoptable-owner']} adoptable={adoptable} />}
    </div>
  );
};
MobileSubmissionDetails.displayName = 'MobileSubmissionDetails';

export default MobileSubmissionDetails;
